import { RouteConfig } from 'config/constants/route'
import { useRouter } from 'next/router'
import React from 'react'
import { Trans } from 'react-i18next'
import { useCloseMenu, useMenuContainer } from 'state/app/hooks'
import { Icons } from 'svgs'
import Link from 'UIKit/Link'
import { StyledText, StyledWrapIcon, StyledWrapTab } from './styled'

const HomeItem = () => {
  const closeMenu = useCloseMenu()
  const { asPath } = useRouter()
  const { isMenuOpen } = useMenuContainer()

  return (
    <StyledWrapTab id="bottom-bar-home" as={Link} onClick={closeMenu} href={RouteConfig.Home}>
      <StyledWrapIcon $active={!isMenuOpen && asPath === RouteConfig.Home}>
        <Icons.HomeIcon />
      </StyledWrapIcon>
      <StyledText $active={!isMenuOpen && asPath === RouteConfig.Home}>
        <Trans>Home</Trans>
      </StyledText>
    </StyledWrapTab>
  )
}

export default React.memo(HomeItem)
